var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lumi-banner mb-5 px-4 py-3" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n        col-12 col-lg-4\n        pt-3 pt-lg-0\n        d-flex\n        align-items-center\n        justify-content-end\n      ",
          on: { click: _vm.handleButtonClick }
        },
        [
          _c("div", { staticClass: "btn flat-btn primary-blue-btn" }, [
            _vm._v("Chat on Slack")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-lg-8 d-flex align-items-center" },
      [
        _c("div", { staticClass: "pr-3" }, [
          _c("div", { staticClass: "white-circle" }, [
            _c("img", {
              staticClass: "lumi-img",
              attrs: {
                src: require("@/assets/image/lumi-character.png"),
                alt: "Lumi"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "title" }, [_vm._v("Chat with Lumi")]),
          _vm._v(" "),
          _c("div", [
            _vm._v("Get answers to your common questions and support issues")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-891cf6a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-891cf6a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact-support/LumiBanner.vue
// module id = null
// module chunks = 